export const initialLibraryView = () => {
  try { return localStorage.getItem('sp_library_view') === 'all' ? 'all' : 'packs'; } catch { return 'packs'; }
};

export const libraryViewReducer = (state, action) => {
  switch (action.type) {
    case 'VIEW': return { ...state, view: action.view, pack: null, packLoops: null, packTab: 'Melodies' };
    case 'OPEN_PACK': return { ...state, view: 'pack', pack: action.pack, packLoops: null, packTab: 'Melodies' };
    case 'PACK_LOOPS': return { ...state, packLoops: action.loops };
    case 'PACK_TAB': return { ...state, packTab: action.tab };
    default: return state;
  }
};
